import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { UserService } from '../../core/user/user.service';
import { NgxSmartModalComponent } from 'ngx-smart-modal';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Business } from '../../core/business/business';
import { ActivatedRoute, Router } from '@angular/router';
import { GuidedSetupStepType } from '../../guided-setup/guided-setup.service';
import { AnalyticsEvent, InternalAnalyticsService } from '../../core/internal-analytics.service';
import { DataStorage } from '../../core/data/data-storage';
import { take } from 'rxjs/operators';
import { WEBSITE_URL_PATTERN } from '../../shared/validators/website-url.validator';
@Component({
    selector: 'rosie-create-account',
    templateUrl: './create-account.component.html',
    styleUrls: ['./create-account.component.scss'],
    standalone: false
})
export class CreateAccountComponent implements OnInit, AfterViewInit {
  persistentStorage: DataStorage = DataStorage.persistent();
  inProgress = false;
  sourceTrainingForm = this.fb.group({
    name: '',
    placeId: '',
    url: ['', Validators.pattern(WEBSITE_URL_PATTERN)]
  });
  accountCreationStep = AccountCreationStep.Details;
  @ViewChild('createAccountModal') createAccountModal: NgxSmartModalComponent;

  private shouldAutoOpen = false;

  constructor(private user: UserService, private translate: TranslateService, private fb: FormBuilder, private router: Router, private route: ActivatedRoute, private analytics: InternalAnalyticsService) {

  }

  ngOnInit(): void {
    this.route.queryParams.pipe(take(1)).subscribe(params => {
      if (params['createAccount'] === 'true') {
        this.router.navigate([], { queryParams: { createAccount: null }, queryParamsHandling: 'merge', replaceUrl: true });
        this.shouldAutoOpen = true;
      }
    });
  }

  ngAfterViewInit(): void {
    if (this.shouldAutoOpen && this.createAccountModal) {
      setTimeout(() => this.createAccountModal.open());
    }
  }

  get headingIcon(): string {
    return this.isDetailsStep ? 'heroBuildingStorefront' : 'heroSparklesSolid';
  }

  get headingTranslation(): string {
    const headingTranslationKey = this.isDetailsStep ? 'MULTI_ACCOUNT.CREATE_A_NEW_ACCOUNT' : 'MULTI_ACCOUNT.TRAIN_NEW_AGENT';
    return this.translate.instant(headingTranslationKey);
  }

  get actionTranslationKey() {
    return this.isDetailsStep ? 'MULTI_ACCOUNT.LETS_START' : 'MULTI_ACCOUNT.CREATE_NEW_ACCOUNT_ACTION';
  }

  get isDetailsStep(): boolean {
    return this.accountCreationStep === AccountCreationStep.Details;
  }

  handleAction() {
    if (this.accountCreationStep === AccountCreationStep.Details) {
      this.accountCreationStep = AccountCreationStep.Training
    } else {
      this.createAccount();
    }
  }


  onPlaceDetailsChanged(placeDetails: any) {
    this.sourceTrainingForm.patchValue({ name: placeDetails.name });
  }

  onPlaceIdChanged(placeId: string) {
    this.sourceTrainingForm.patchValue({ placeId });
  }

  clearSelection() {
    this.sourceTrainingForm.patchValue({ placeId: null });
  }


  private createAccount() {
    const sourceData = this.sourceTrainingForm.value;
    const placeId = sourceData?.placeId;
    const url = sourceData?.url;
    if (!placeId && !url || this.sourceTrainingForm.get('url')?.invalid) {
      return;
    }
    this.inProgress = true;
    this.user.createBusiness({ placeId, url }).subscribe((business: Business) => {
      this.analytics.trackEvent(AnalyticsEvent.AccountCreated);
      this.persistentStorage.set('isAwaitingInitialSetup', true);
      this.user.switchToBusiness(business.id).subscribe(() => {
        this.createAccountModal.close();
        this.accountCreationStep = AccountCreationStep.Details;
        this.inProgress = false;
        this.router.navigate(['/setup', { step: GuidedSetupStepType.Train }]);
      });
    }
    );
  }
}

export enum AccountCreationStep {
  Details = 1,
  Training = 2
}